(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .factory('contactRequestService', contactRequestService);

  /* ngInject */
  function contactRequestService($resource, config) {
    let url = `${config.complianceFrameworkApiEndpoint}/api/contact_request`;
    let paramDefaults = {};
    let actions = {
      'save': {method: 'POST'}
    };

    return $resource(url, paramDefaults, actions);
  }
})();
